// pull title string
// get length
// clamp with css
// check length with if to determine font size
    // if length is < x, add small
    // if length is < y, add med

export class BlogTitleNormalization
{
  constructor()
  {
    let blogTitles = document.querySelectorAll('.blog-preview-card:not(.large) .blog-preview-content-title > a') as HTMLCollectionOf<HTMLElement>;

    for (let i = 0; i < blogTitles.length; i++) {
     
      // get length of title
      let titleLength = blogTitles[i].innerText.length;
      
      if (titleLength > 55) {
        blogTitles[i].classList.add('fade');
      } else if (titleLength > 45) {
        blogTitles[i].classList.add('small');
      } else if ( titleLength > 30){
        blogTitles[i].classList.add('medium');
      } else if (titleLength > 10) {
        blogTitles[i].classList.add('large');
      }
    }
  }
}


// WEBPACK FOOTER //
// ./Static/javascript/modules/blog-title-normalization.ts